module.exports = __webpack_public_path__ + "img/logout.c43bded4.svg";